import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { JqHelper } from 'src/app/common/jq-helper';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { G_PurchaseMasterViewModel } from 'src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel';
import { PurchaseDetailViewModel } from 'src/app/viewmodels/g-purchase/PurchaseDetailViewModel';
import { GPackagesViewModel } from 'src/app/viewmodels/g-packages/GPackagesViewModel';
import { GPackageItemViewModel } from 'src/app/viewmodels/g-packages/GPackageItemViewModel';
import { GPackagesModelViewModel } from 'src/app/viewmodels/g-packages/GPackagesModelViewModel';
import { ActivatedRoute, Router } from '@angular/router';
import { G_ComplainsSuggestionsViewModel } from 'src/app/viewmodels/g-settings/G_ComplainsSuggestionsViewModel';
import { AccountDefiningModel, DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { SaleDetailViewModel } from 'src/app/viewmodels/g-sale/SaleDetailViewModel';
import { G_PackagesTypeViewModel } from 'src/app/viewmodels/g-packages/G_PackagesTypeViewModel';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2/dist/sweetalert2.all.js';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { ComplainsSuggestionsModel, GPackagesModel, SaleDetailModel, SaveSaleMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { SaveGVehicleRequest, SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { AppConsts } from 'src/app/common/app-consts';
@Component({
  selector: 'app-repair-invoice',
  templateUrl: './repair-invoice.component.html',
  styleUrls: ['./repair-invoice.component.scss']
})
export class RepairInvoiceComponent implements OnInit {
  disabled = true;
  @Input() public vmC: ComplainsSuggestionsModel;
  @Input() public vmD: AccountDefiningModel;
  @Input() public vmP: GPackagesModel;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  modalRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>(); public component_Title = 'Sale';
  public vehicleDetail: any = [];
  public complaintsType: any = [];
  public ccomplaintsType: 'complaintsType';
  public packageTypes: any = [];
  public cvehicleDetail = 'vehicleDetail';
  public selectedvehicleDetail: any = [];
  public itemVm: SaveGVehicleRequest = new SaveGVehicleRequest();
  public sparePartVm: SaveItemRequest = new SaveItemRequest();
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public vmDetail: number = 15;
  public saleDetailVM: any = [];
  public services: any = [];
  public selectedServices: any = [];
  public cpackageTypes = 'packageTypes';
  public items: any = [];
  public brands: any = [];
  public selectedBrands: any = [];
  public models: any = [];
  public selectedModels: any = [];
  public citems: any = 'items';
  public cbrands: any = 'brands';
  public cmodels: any = 'models';
  public spareParts: any = [];
  public selectedSpareParts: any = [];
  public selectedPacakgeTypes: any = [];
  public tags: any = [];
  public selectedTagList: any;
  public selectedsaleDetail: any[];
  public saleDetail: any[];
  public csaleDetail: any[];
  submitted: boolean;
  public customerDetail: any = [];
  public selectedcustomerDetail: any = [];
  public DisableSave: boolean = false;
  public EnableNext: boolean = false;
  public isPreview: boolean = false;
  public thumbnail: any;
  public ComName: any;
  public Address: any;
  public contect: any;

  public brandsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public modelsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public CustomerDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'accTitle',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public accountDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'accTitle',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };

  public itemTypes = [];
  public ssItemVm = new GItemDefiningViewModel();
  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'registrationNumber',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  files: File[] = [];
  public calingUrl: string;
  public urlId: string;
  public client: any;

  public TotalPayable = 0;
  public TotalVat = 0;
  public TotalPayableAfterVat = 0;
  public DiscountTotal = 0;
  public partsAmount = 0;
  public serviceAmount = 0;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }
  name = 'cpEmail';
  id = 'id';
  checked = true;
  isdisabled = false;
  label = 'Toggle On/Off';
  labelledby = 'Some Other Text';



  ngOnInit() {
    debugger
    this.client = this._localStorageService.get("com");
    this.vmDetail = parseInt(this.client.Vat);
    let date = new Date();
    document.getElementById("date").innerHTML = date.toLocaleDateString();
    this.getimage();
    this.customerDetail = [];
    this.selectedcustomerDetail = [];
    this.vm = new SaveSaleMasterRequest();
    this.getCustomers();
    this.vm.customerAccEmail = new ItemViewModel1(0, "");
    this.saleDetailVM = new SaleDetailModel();
    this.vm.statusType = new ItemViewModel1(8, "");
    this.vm.gVehicle = new ItemViewModel1(0, "");
    this.vm.gCustomer = new ItemViewModel1(0, "");
    this.vm.brand = new ItemViewModel1(0, "");
    this.vm.model = new ItemViewModel1(0, "");
    //console.log(this.vm);
    debugger
    let id = this.route.snapshot.params['Id'];
    this.calingUrl = this._router.url;
    this.route.queryParams.subscribe(params => {
      this.urlId = params['id'];
    });
    // this._jq.showSpinner(true);
    this.spinner.show();
    debugger
    this._uow.gSaleService.GetGSaleByIdAsync(this.urlId).subscribe((res: any) => {
      console.log(res);
      this.vm = res;
      // this._jq.showSpinner();
      this.spinner.hide();
      debugger
      this.vm.paymentType = 1;
      this.vm.customerAccEmail = new ItemViewModel1(res.customerAccEmail.id. res.customerAccEmail.name)
      this.vatChanged();
      console.log(this.vm);

    }, (err) => {
      console.log(err);
      // this._jq.showSpinner();
      this.spinner.hide();
    })

    if (this.vm.salesTagsList !== undefined && this.vm.salesTagsList.length > 0) {
      this.vm.salesTagsList.forEach(x => {
        this.selectedTagList.push(new ItemViewModel1(x.id, x.name));
      });
    }
    this.getTags();
    this.DisableSave = false;
    this.isPreview = false;
    this.vm.isEmailRequired = true;

  }

  onChange(e) {
    debugger
    let item = this.vm.customerAccEmail;
    if (item != null) {
      if (e == true) {
        //this.vm.customerAccEmail = new ItemViewModel1(item.id, item.name);
        this.vm.isEmailRequired == true;

      } else {
        //this.vm.customerAccEmail = null;
        this.vm.isEmailRequired == false;

      }
    } else {
      this.vm.customerAccEmail = new ItemViewModel1(0, '');
    }
  }

  getSupCashList() {
    this.vm.customerAcc = new ItemViewModel1();
    //this.getRegNo();
    this.selectedcustomerDetail = [];
    this.getCustomers();
  }

  getCustomers() {
    let Customer = AppConsts.CUSTOMER;
    if (this.vm.paymentType === 2) {
      Customer = "Cash";
    }
    if (this.vm.paymentType === 3) {
      Customer = "Office";
    }
    this._uow.gSettingService.GetGCustomersDropDownAsync(Customer).subscribe((res: any) => {
      debugger
      this.customerDetail = res.result;
      if (this.customerDetail.length > 0) {
        this.customerDetail = res.result.map(x => {
          return {
            id: x.id, // or the actual ID field
            accTitle: x.accCode + '-' + x.accTitle // concatenated name and code
          };
        });
      }
    }, (error) => {
      this._uow.logger.log(error);
      this.customerDetail = [];
    });
  }
  onSelectCustomer(e) {
    let item = this.customerDetail.find(x => x.id === e.id);
    console.log(item);
    if (item !== undefined) {
      this.vm.customerAcc = new ItemViewModel1(item.id, item.accTitle);
      //this.vm.FK_Sup_Cradit_Acc.Id = item.Id;
      //this.vm.FK_Sup_Cradit_Acc.Name = item.Acc_Titel;
    }
  }


  vatChanged() {
    debugger
    if (this.vmDetail > -1) {
      if (this.vm.spareParts !== undefined && this.vm.spareParts.length > 0) {
        this.vm.spareParts.forEach(x => {
          x.vatValue = this.vmDetail;
          x.vatAmount = ((x.totalAmount / 100) * this.vmDetail);
          x.totalVatAmount = x.totalAmount + x.vatAmount;
        });
      }
      if (this.vm.services !== undefined && this.vm.services.length > 0) {
        this.vm.services.forEach(x => {
          x.vatValue = this.vmDetail;
          x.vatAmount = ((x.totalAmount / 100) * this.vmDetail);
          x.totalVatAmount = x.totalAmount + x.vatAmount;
        });
      }
      if (this.vm.saleDetails !== undefined && this.vm.saleDetails.length > 0) {
        this.vm.saleDetails.forEach(x => {
          x.vatValue = this.vmDetail;
          x.vatAmount = ((x.totalAmount / 100) * this.vmDetail)
          x.totalVatAmount = x.totalAmount + x.vatAmount;
        });
      }
      this.calculateTotals();
    }
  }


  calculateTotals() {
    this.TotalPayableAfterVat = 0;
    this.TotalVat = 0;
    this.DiscountTotal = 0;
    this.TotalPayable = 0;
    this.partsAmount = 0;
    this.serviceAmount = 0;
    this.vm.services.forEach(x => {
      this.TotalVat += x.vatAmount;
      //x.TotalAmount = x.TotalAmount+this.TotalVat;
      this.serviceAmount += x.totalAmount;
      if (x.discountAmount >= 0) {
        this.DiscountTotal += (x.discountAmount * x.quantity);
      }
    });
    this.vm.spareParts.forEach(x => {
      this.TotalVat += x.vatAmount;
      //x.TotalAmount = x.TotalAmount+this.TotalVat;
      this.partsAmount += x.totalAmount;

      if (x.discountAmount >= 0) {
        this.DiscountTotal += (x.discountAmount * x.quantity);
      }
    });
    this.vm.invAmount = this.partsAmount + this.serviceAmount + this.TotalVat;
    this.vm.totalExpense = this.vm.invAmount;
    this.vm.allowedExpense = this.vm.invAmount;

  }
  public amountCheck: boolean = false;
  onEnterAmount() {
    if (this.vm.allowedExpense > this.vm.totalExpense) {
      this.amountCheck = true;
      return;
    }
    if (this.vm.allowedExpense <= this.vm.totalExpense) {
      this.amountCheck = false;
    }
  }
  quantityChange(e, i?) {
    e.salePrice = e.quantity * e.discountAmount;
    //  if (e.DescountPercentage > 0) {
    //    e.Amount = (e.Amount - ((e.DescountPercentage / 100) * e.Amount));
    //  }
    this.vatChanged();
  }
  discountChange(e, i?) {
    let discountAMmount = ((e.discountAmount * e.salePrice)) / 100;
    e.discount = discountAMmount;
    e.discountAmount = e.salePrice - e.discount;
    e.salePrice = e.discountAmount * e.quantity;
    // if(this.vmP.DiscountAmount > 0){
    //
    //   this.calculateTotals();
    // }
    // if(this.vmP.DiscountAmount <= 0){
    //   let discountAMmount = ((e.DescountPercentage / 100) * e.Amount);
    //   e.Amount = (e.Amount - discountAMmount);
    //   this.calculateTotals();
    // }
    this.vatChanged();
  }

  vatAmountChanged(i) {
    this.calculateTotals();
  }
  amountChange(e, i?) {
    e.discountAmount = ((e.discount * 100) / e.salePrice);
    this.discountChange(e, i);
    // if(this.vmP.DiscountAmount > 0){
    //
    //   this.calculateTotals();
    // }
    // if(this.vmP.DiscountAmount < 0){
    //   let discountAMmount = (e.Amount-e.DescountAmmount);
    //   e.Amount = (discountAMmount);

    // }
    this.vatChanged();
  }
  onSelect(e) {
    console.log(e);
    this.files.push(...e.addedFiles);

    this.vm.file = this.files;
  }

  onRemove(e) {
    console.log(e);
    this.files.splice(this.files.indexOf(e), 1);
  }

  getTags() {
    this._uow.gSettingService.GetTagsAsync().subscribe((res: any) => { this.tags = res.result; }, (err) => console.log(err));
  }
  getimage() {

    this._uow.gSettingService.GetHeaderFootersDropDownAsync().subscribe((baseImage: any) => {
      console.log(baseImage);
      debugger;
      if (baseImage != undefined && baseImage !== null) {
        if (baseImage.attachment != undefined && baseImage.attachment !== null) {

          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        } else {
          this.thumbnail = baseImage.compName;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        }
      }
    }, (err) => {
      console.log(err);
    })
  }

  onItemSubmitted(e) {
    if (e == true) {
      //this.getList();
      this.getTags();
      this._jq.showSpinner(false);
    }
  }
  saveOrUpdate() {
    debugger
    if (this.vm.paymentType == 1) {
      this.onChange(true);
    }
    this.vm.isEmailRequired = true;
    this.vm.statusType = new ItemViewModel1(8, "SaleInvoice");
    //this.vm.Inv_Amount = this.vmP.PackageAmount
    this.vm.paidAmount = this.vm.invAmount;
    // this._jq.showSpinner(true);
    this.spinner.show();
    this._uow.gSaleService
      .SaveGSaleAsync(this.vm)
      .toPromise().then((res: any) => {
        console.log(res);
        // this._jq.showSpinner();
        this.spinner.hide();
        this.submitted = true;
        this.onSubmitted.emit(this.submitted);
        Swal.fire(
          'Saved!',
          'Repair Order Updated!',
          'success'
        )
        this.EnableNext = true;

      })
      .catch((error) => {
        Swal.fire(
          'Error!',
          'Repair Order Not Updated!',
          'warning'
        )
        this._uow.logger.log(`Promise rejected with ${JSON.stringify(error)}`);
        console.log(error);
        this.onSubmitted.emit(false);
        // this._jq.showSpinner();
        this.spinner.hide();
      });
    this.modalRef.hide();
  }

  navigateClick() {
    // this.isPreview = false;
    this.modalRef.hide()
  }

  nextPage(item) {
    debugger
    if (item.PaymentType == 1) {
      alert("Hello");
    } else {
      alert("World");
    }
  }

  openPreview(content) {
    debugger
    this.modalRef = this._uow.modalServiceEx.show(content);
    this.modalRef.setClass('modal-lg');
    this.isPreview = true;
  }



























































  // getSpareParts(e) {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this._uow.logger.log(e);
  //   let item = this.saleDetail.find(x => x.Id === e.Id);
  //   if (item !== undefined) {
  //     // let a =  new GPackageItemViewModel();
  //     // a.Quantity = 1;
  //     // a.Fk_G_SSItemDefining_Id = e;
  //     // a.DescountPercentage = 0;
  //     // a.SalePrice = item.SalePrice;
  //     // a.Amount = 0;
  //     // a.Amount = item.SalePrice;
  //     item.SaleDetails.forEach(x => {

  //       if (x.FK_G_Item_Type_Id.Id === 18) {
  //         let selectedparts = this.spareParts.find(y => y.Id === x.Fk_G_SSItemDefining_Id.Id);

  //         if (selectedparts !== undefined) {
  //           let i = new SaleDetailViewModel();
  //           i.Quantity = 1;
  //           i.FK_G_Item_Id = new ItemViewModel(selectedparts.Id, selectedparts.Name);
  //           i.FK_G_Item_Type_Id = new ItemViewModel(selectedparts.Id, selectedparts.Name);
  //           // i.AvalibelQuantity = item.CurrentStock;
  //           // i.Quantity = item.CurrentStock;
  //           i.Item_Code = selectedparts.Code;
  //           i.Item_Name = item.Name;
  //           i.PurchasePrice = x.SalePrice;
  //           i.SalePrice = x.SalePrice;
  //           i.Item_Type = selectedparts.FK_G_ItemType_Id.Name;
  //           i.VatAmount = 0;
  //           i.VAT_Value = 0;
  //           //this.vm.SaleDetails.push(i);
  //           let a = new GPackageItemViewModel();
  //           a.Quantity = 1;
  //           a.Fk_G_SSItemDefining_Id = e;
  //           a.DescountPercentage = x.DescountPercentage;
  //           a.SalePrice = x.SalePrice;
  //           a.Amount = 0;
  //           a.Amount = x.SalePrice;
  //           a.DiscountAmount = 0;
  //           //this.vmP.SpareParts.push(a);
  //         }

  //       }

  //       if (x.FK_G_Item_Type_Id.Id === 19) {
  //         let selectedservices = this.services.find(y => y.Id === x.Fk_G_SSItemDefining_Id.Id);
  //         if (selectedservices !== undefined) {
  //           let i = new SaleDetailViewModel();

  //           i.FK_G_Item_Id = new ItemViewModel(item.Id, item.Name);
  //           i.FK_G_Item_Type_Id = new ItemViewModel(selectedservices.Id, selectedservices.Name);
  //           //i.AvalibelQuantity = item.CurrentStock;
  //           i.Quantity = 1;
  //           i.Item_Code = selectedservices.Code;
  //           i.Item_Name = item.Name;
  //           i.PurchasePrice = x.SalePrice;
  //           i.SalePrice = x.SalePrice;
  //           i.Item_Type = selectedservices.FK_G_ItemType_Id.Name;
  //           i.VatAmount = 0;
  //           i.VAT_Value = 0;
  //           //this.vm.SaleDetails.push(i);
  //           let a = new GPackageItemViewModel();
  //           a.Quantity = 1;
  //           a.Fk_G_SSItemDefining_Id = e;
  //           a.DescountPercentage = x.DescountPercentage;
  //           a.SalePrice = x.SalePrice;
  //           a.Amount = 0;
  //           a.Amount = x.SalePrice;
  //           //this.vmP.Services.push(a);
  //           // this._jq.showSpinner();
  //           this.spinner.hide();
  //         }

  //       }
  //     });
  //     //this.vmP.SpareParts.push(a);
  //     //  this._jq.showSpinner();
  //     this.spinner.hide();
  //   }
  // }

  // openModal(template: TemplateRef<any>, lvl: number = 1) {
  //   if (lvl == 1) {
  //     this.modalRef = this._uow.modalServiceEx.show(template);
  //   }
  //   // if (lvl == 2) {
  //   //   this.modalRefLv2 = this._modalService.show(template);
  //   // }
  // }

  // openModalLg(template: TemplateRef<any>, itemtype?) {
  //   this.ssItemVm = new GItemDefiningViewModel();
  //   if (itemtype == 1) {
  //     let i = this.itemTypes.find(x => x.Name == 'Spare-Parts');
  //     console.log(i)
  //     this.ssItemVm.FK_G_ItemType_Id = new ItemViewModel(i.Id, i.Name);
  //   }
  //   if (itemtype == 2) {
  //     let i = this.itemTypes.find(x => x.Name == 'Services');
  //     this.ssItemVm.FK_G_ItemType_Id = new ItemViewModel(i.Id, i.Name);
  //   }
  //   this.openModal(template);
  //   this.modalRef.setClass('modal-lg');
  // }

  // OpenCreateDirectInvoice(e) {
  //   this._router.navigate(['/updated-invoice', { Id: e }]);
  // };

  // saleCompleted() {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   let obj = this.itemVm;
  //   console.log();
  //   // this._jq.showSpinner();
  //   if (this.vm.PaymentType == 1) {
  //     this.onChange(true);
  //   }
  //   this.vm.IsEmailRequired == true;
  //   this.vm.Fk_G_StatusType_Id = new ItemViewModel(8, "SaleInvoice");
  //   this.vm.ServiceAmount = this.serviceAmount;
  //   this.vm.PartsAmount = this.partsAmount;
  //   // this._jq.showSpinner(true);
  //   this._uow.saleService
  //     .PostSave(this.vm)
  //     .toPromise().then((res: any) => {
  //       console.log(res);
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //       this.submitted = true;
  //       this.onSubmitted.emit(this.submitted);
  //       Swal.fire(
  //         'Saved!',
  //         'Repair Order Updated!',
  //         'success'
  //       )
  //       this.EnableNext = true;

  //     })
  //     .catch((error) => {
  //       Swal.fire(
  //         'Error!',
  //         'Repair Order Not Updated!',
  //         'warning'
  //       )
  //       this._uow.logger.log(`Promise rejected with ${JSON.stringify(error)}`);
  //       this.onSubmitted.emit(false);
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     });
  // }



}
